import { Route, Routes } from "react-router-dom";
import { TriggersCreatedPage, TriggersTemplatePages, TriggersLogsPage } from "./pages";
import { TriggersProvider } from "./context/TriggersContext";
import TriggerViewPage from "./pages/TriggerViewPage/TriggerViewPage";
import { TriggersLogsProvider } from "./context/TriggersLogsContext";


const PMSystemPage = () => {
  return (
    <TriggersProvider>
      <Routes>
        <Route index element={<TriggersCreatedPage />} />
        <Route path="templates" element={<TriggersTemplatePages />} />
        <Route path="logs" element={
          <TriggersLogsProvider>
            <TriggersLogsPage />
          </TriggersLogsProvider>
        } />
        <Route path=":triggerId/*" element={<TriggerViewPage />} />
      </Routes>
    </TriggersProvider>
  );
};

export default PMSystemPage;
